import { Grid } from "@mui/material";

import { styled } from "@mui/material";

const MxDataTableCell = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));

const MxDataTableCellText = styled("span")<{ align?: "center" | "left" | "right" }>(
  ({ theme, align, color }) => ({
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: color ? color : theme.palette.grey[700],
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: align || "left",
    width: "100%"
  })
);

export { MxDataTableCell, MxDataTableCellText };
